import { TypeInitProps } from '../types';
import { WEB_URL, WEB_AFF_URL, WEB_SSO } from './urls';

function loadScript(url: string, callback: () => void) {
  let script: any = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
  if (script.readyState) {
    script.onreadystatechange = function() {
      if (script.readyState === 'complete' || script.readyState === 'loaded') {
        script.onreadystatechange = null;
        callback && callback();
      }
    };
  } else {
    script.onload = function() {
      callback && callback();
    };
  }
}

function getEnablePathList() {
  return ([] as string[]).concat(
    Object.values(WEB_URL),
    Object.values(WEB_AFF_URL),
    Object.values(WEB_SSO)
  );
}

function getUrlRewriteRules() {
  const rewriteRuleList = Object.values(WEB_SSO).map(item => {
    return [item, '/passport/sso' + item];
  });
  return rewriteRuleList || [];
}

function setAcrawlerConfig(options: TypeInitProps) {
  let byted_acrawler = (window as any).byted_acrawler;
  let enablePathList = getEnablePathList();
  let urlRewriteRules = getUrlRewriteRules();
  if (byted_acrawler) {
    byted_acrawler.init({
      sdi: options.sdi,
      aid: options.aid,
      // isSDK 为 true 并不会初始化，只会追加配置
      isSDK: true,
      // dfp: options.acrawler === 'cn' ? true : false,
      boe: options.isBoe || false,
      // intercept: true,
      enablePathList,
      urlRewriteRules,
    });
  }
}

export function initAcrawler(region: string, options: TypeInitProps) {
  let url =
    'https://sf16-secsdk.ibytedtos.com/obj/rc-web-sdk-gcs/webmssdk/1.0.0.303/webmssdk.js';
  if (region === 'gcp' || region === 'giso') {
    url = 'https://sf16-secsdk.ibytedtos.com/obj/rc-web-sdk-giso/webmssdk.js';
  } else if (region === 'sg') {
    url =
      'https://sf16-secsdk.ibytedtos.com/obj/rc-web-sdk-sg/webmssdk/1.0.0.303/webmssdk.js';
  } else if (region === 'va' || region === 'gcs') {
    url =
      'https://sf16-secsdk.ibytedtos.com/obj/rc-web-sdk-gcs/webmssdk/1.0.0.303/webmssdk.js';
  }
  if (options.acrawlerUrl) {
    url = options.acrawlerUrl;
  }
  if ((window as any).byted_acrawler) {
    setAcrawlerConfig(options);
  } else {
    // Notice: 风控预期是让业务方自行引入 mssdk ，我们只新增 /passport 路径收集的配置项，不能帮业务引入并初始化。
    // 原因是合规问题——仅能让业务自行决定要不要采集信息，对接人 @张鸿博 @段湛洋
    loadScript(url, () => {
      setAcrawlerConfig(options);
    });
  }
}
